import { WidgetI18nProvider } from '@elfsight/widget-i18n';
import { useCustomJS, useDefineAPISchema } from '@elfsight/widget-js-api';
import { PortalNestProvider } from '@elfsight/widget-modal';
import {
  CustomCSS,
  createCustomCSSPrefixClassName,
  EmbedRoot,
  useFontsLoader
} from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import DICTIONARY from '../language/dictionary.json';
import { meta } from './meta';
import type { JobBoardSettings } from './types';
import {
  FiltersWithThemeProvider,
  JobFilterProvider,
  SearchProvider
} from './widget/filters';
import { LayoutProvider } from './widget/layout';
import { PopupProvider } from './widget/popup';
import { Widget } from './widget/Widget';

export function JobBoard(_settings: JobBoardSettings) {
  const settings = useSettings();
  const {
    customCSS,
    customJS,
    font,
    editMode,
    widgetId,
    renderThumbnailMode,
    language
  } = settings;
  const customCSSPrefixClassName = createCustomCSSPrefixClassName(
    meta.appAlias,
    widgetId
  );

  useDefineAPISchema();
  useCustomJS(customJS, editMode || renderThumbnailMode);
  useFontsLoader([font]);

  return (
    <WidgetI18nProvider
      dictionary={DICTIONARY}
      language={language?.language ?? 'en'}
      override={language?.messages ?? {}}
    >
      <PortalNestProvider
        customCSSClassName={customCSSPrefixClassName}
        font={font}
      >
        <PopupProvider>
          <LayoutProvider>
            <FiltersWithThemeProvider>
              <SearchProvider>
                <JobFilterProvider>
                  <CustomCSS
                    customCSS={customCSS}
                    prefixClassName={customCSSPrefixClassName}
                  />
                  <EmbedRoot
                    className="RootLayout__RootComponent-sc" // legacy class
                    customCSSClassName={customCSSPrefixClassName}
                    font={font}
                  >
                    <Widget />
                  </EmbedRoot>
                </JobFilterProvider>
              </SearchProvider>
            </FiltersWithThemeProvider>
          </LayoutProvider>
        </PopupProvider>
      </PortalNestProvider>
    </WidgetI18nProvider>
  );
}
